export default __webpack_public_path__ + "static/media/vegan-and-vegetarian-coffee-shops-and-restaurants-in-europe.170ee4d7.png";